import type React from "react";
import { useContext } from "react";
import { GameContext } from "../../../../app/context/GameContext";
import style from "./GameModal.module.scss";

type GameModalProps = {
	children: React.ReactNode;
	setOpenGameModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GameModal: React.FC<GameModalProps> = ({
	children,
	setOpenGameModal,
}) => {
	const { setGameModalOpen } = useContext(GameContext);
	return (
		<div className={style.gameModal}>
			<button
				type="button"
				onClick={() => {
					setOpenGameModal(false);
					setGameModalOpen(false);
				}}
				className={style.closeBtn}
			>
				x
			</button>
			{children}
		</div>
	);
};
